export const onLoadImage = (url, cb) => {
	let img = new Image()
	img.onload = cb
	img.src = url
}
